var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.923,
    height: 38.926,
    viewBox: "0 0 38.923 38.926",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video",
    transform: "translate(-4.004 -3.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140047",
    "data-name": "Path 140047",
    d: "M38.868,26.646c0-10.517-12.579-16.077-20.321-9.1a12.249,12.249,0,0,0,0,18.2c7.743,6.979,20.322,1.419,20.321-9.1Zm-7.5.576L24.652,31.7a.7.7,0,0,1-1.076-.576V22.174a.683.683,0,0,1,.368-.611.669.669,0,0,1,.708.035l6.716,4.473a.7.7,0,0,1,0,1.153Z",
    transform: "translate(-3.2 -3.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140048",
    "data-name": "Path 140048",
    d: "M29.555,33.779l4.764-3.174-4.764-3.175Z",
    transform: "translate(-7.79 -7.144)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140049",
    "data-name": "Path 140049",
    d: "M48.238,47.253l-2.167-2.167a10.03,10.03,0,0,1-.979.979l2.167,2.167a4.528,4.528,0,1,0,.979-.979Z",
    transform: "translate(-12.527 -12.527)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140050",
    "data-name": "Path 140050",
    d: "M13.388,45.086l-2.167,2.167a4.528,4.528,0,1,0,.979.979l2.167-2.167a10.025,10.025,0,0,1-.979-.979Z",
    transform: "translate(0 -12.527)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140051",
    "data-name": "Path 140051",
    d: "M46.071,14.363,48.238,12.2a4.528,4.528,0,1,0-.979-.979l-2.167,2.167A10.02,10.02,0,0,1,46.071,14.363Z",
    transform: "translate(-12.527 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140052",
    "data-name": "Path 140052",
    d: "M8.565,13.071a4.464,4.464,0,0,0,2.674-.875l2.167,2.167a10.026,10.026,0,0,1,.979-.979l-2.167-2.167a4.5,4.5,0,1,0-3.653,1.854Z",
    transform: "translate(-0.018 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.d6a2a4d2f15858f8831c1f15bb070947.svg";
export { ForwardRef as ReactComponent };